// extracted by mini-css-extract-plugin
export var container = "Intro-module--container--ce2ec";
export var cta = "Intro-module--cta--ac679";
export var discover = "Intro-module--discover--b69b6";
export var highlight = "Intro-module--highlight--4536f";
export var slideAndFade = "Intro-module--slide-and-fade--82e29";
export var startPlaying = "Intro-module--startPlaying--f13a5";
export var subtitle = "Intro-module--subtitle--06cd3";
export var title = "Intro-module--title--dd668";